// Generated by CoffeeScript 2.7.0
import "./application_init.js";
import $ from "jquery";

TryItParent.namespace('addressFormChange');

TryItParent.addressFormChange = function() {
  var domestic, foreignClass, internalClass, postcodeClass;
  domestic = $('.isAdress').find(':checked').val();
  internalClass = '.js__address__internal';
  foreignClass = '.js__address__foreign';
  postcodeClass = 'js__postcode';
  if (domestic === 'true') {
    $(internalClass).removeAttr('disabled');
    $(internalClass).removeClass('input-disabled');
    $(foreignClass).attr('disabled', 'disabled');
    $(foreignClass).addClass('input-disabled');
    $('#postcode').addClass(postcodeClass);
  } else if (domestic === 'false') {
    $(foreignClass).removeAttr('disabled');
    $(foreignClass).removeClass('input-disabled');
    $(internalClass).attr('disabled', 'disabled');
    $(internalClass).addClass('input-disabled');
    $('#postcode').removeClass(postcodeClass);
  } else {

  }
};
